/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';
import _ from 'lodash';

// ours
import { OptionsBoxViewModel } from 'src/types/view-models/options-box.view.model';
import { ButtonSecondary } from '@americanexpress/dls-react';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// icons and styles
import styles from './OptionsBox.module.scss';
import PlaidButton from 'src/bw/bw-drawer/PlaidButton';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';

const setClickerMarkup = (props: OptionsBoxViewModel): JSX.Element => {
    switch (true) {
        case props.hasPlaidButton:
            return (
                <PlaidButton
                    handleClearFirstImport={props.handleClearFirstImport}
                    handleFirstImport={props.handleFirstImport}
                    handleReloadUser={props.handleReloadUser}
                    firstImport={props.firstImport}
                    setDrawer={props.setDrawer}
                    className="plaid-button"
                    user={props.user}
                    handleAccounts={props.handleAccounts}
                    handleSuccess={async () => await props.handleSuccess()}
                    data-cy={Selectors.General.OPTIONS_BOX_BUTTON}
                >
                    {LiteralsService.getLiteral('Onboarding.connectAccount')}
                </PlaidButton>
            );
        case props.onClick !== undefined:
            return (
                <ButtonSecondary
                    onClick={props.onClick}
                    size="sm"
                    data-cy={Selectors.General.OPTIONS_BOX_BUTTON}
                    className={props.buttonStyle}
                >
                    {props.buttonText}
                </ButtonSecondary>
            );
        default:
            return null;
    }
};

export default function OptionsBox(props: OptionsBoxViewModel): JSX.Element {
    const clicker: JSX.Element = setClickerMarkup(props);

    return (
        <div className={[styles.optionsBox, props.isBlue ? styles.blueBackground : ''].join(' ')} data-cy="options-box">
            <div className={styles.header}>
                <div className={styles.iconContainer}>{props.icon}</div>
                <Typography component="h4" variant={TypographyVariants.BODY_BOLD}>
                    {props.headerText}
                </Typography>
            </div>
            {props.children ? (
                props.children
            ) : (
                <>
                    <div className={styles.bodyText}>
                        {_.map(props.content, (contentString, index) => {
                            return (
                                <Typography
                                    variant={TypographyVariants.SUBTEXT}
                                    component={'div'}
                                    className={styles.paragraph}
                                    key={index}
                                >
                                    {contentString}
                                </Typography>
                            );
                        })}
                    </div>
                    {clicker}
                </>
            )}
        </div>
    );
}
